module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/chicken-star2.a71b7cc6.png";